import { request } from '@api/request'

const BASE_URL = 'esri'

interface TenerifeTokenData {
  token: string
  expires: number
  ssl: boolean
}

export const esri = {
  getTenerifeWildfireOperativityLayerToken: () => {
    return request.get<TenerifeTokenData>(`${BASE_URL}/cabildoTenerifeToken`)
  }
}
